import { Button } from "antd"
import { memo } from "react"

export const FlowFiles = memo(() => {
  return <div><Button type="primary">Create New</Button></div>
})